import {
  formatBalance,
  formatDate,
  IconSelected,
  SelectItemProps,
} from '@ui/src';
import { Account } from '../../types';

import cn from '../styles.module.css';

const formatAccountsList = (
  list: Account[],
  currencies?: SelectItemProps[],
  overdraftEnabled?: boolean,
  closingBalancesAt?: string,
): Account[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {
      closed: <div>{result.closed ? 'Closed' : 'Open'}</div>,
      createdAt: <div>{formatDate(result.createdAt)}</div>,
      closedAt: <div>{formatDate(result.closedAt)}</div>,
      search: <div className={cn.clientName}>{result.description}</div>,
      fullNumber: <div className={cn.fullNumber}>{result.fullNumber}</div>,
      debitBlock: <div>{result.debitBlock ? 'Withdrawals blocked' : ''}</div>,
      creditBlock: <div>{result.creditBlock ? 'Top-up blocked' : ''}</div>,
      accountType: (
        <div className={cn.accountType}>{result.accountType.toLowerCase()}</div>
      ),
      overdraftEnabled: (
        <div>
          {result.overdraftEnabled ? (
            <IconSelected
              width={15}
              height={13}
              className={cn.overdraftEnabled}
            />
          ) : (
            <div className={cn.overdraftDisabled} />
          )}
        </div>
      ),
    };

    currencies?.forEach((currency) => {
      if (
        result?.balances?.find(
          (balance) => balance.currencyId === currency.value,
        )
      ) {
        const currentBalance = result?.balances?.find(
          (balance) => balance.currencyId === currency.value,
        );

        let currentClosingBalance;

        if (result?.closingBalances) {
          currentClosingBalance = result?.closingBalances?.find(
            (balance) => balance.currencyId === currency.value,
          );
        }

        if (currentBalance) {
          render[currency.value] = (
            <div className={currentBalance.value < 0 ? cn.negativeBalance : ''}>
              <div className={cn.currentBalance}>
                {formatBalance(currentBalance.value, currentBalance.currency)}
              </div>
              {currentClosingBalance && closingBalancesAt && (
                <div
                  className={`${cn.closingBalance} ${
                    currentClosingBalance.value < 0 ? cn.negativeBalance : ''
                  }`}
                >
                  {formatBalance(
                    currentClosingBalance?.value,
                    currentClosingBalance?.currency,
                  )}
                </div>
              )}
              {overdraftEnabled && result.overdraftEnabled && (
                <div className={cn.overdraftValue}>
                  {currentBalance.overdraftEnabled ? (
                    formatBalance(
                      currentBalance?.overdraftValue as number,
                      currentBalance.currency,
                    )
                  ) : (
                    <div className={cn.noOverdraft} />
                  )}
                </div>
              )}
            </div>
          );
        }
      }
    });

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatAccountsList;
